import { ApplicationFeature, DefaultApplicationFeatures } from "./Features";
import { Partner } from "./Partners";

export class Site
{
    constructor(
        public id: string,
        public settings: SiteSettings,
        public companyInfo: CompanyInfo,
        public partner: Partner | null,
        public loginName: string
    ) { }
}

export type SiteSettings = {
    enabled: boolean,
    hideSurveyEmailAddresses: boolean,
    apiVideoKey: string,
    features: ApplicationFeature[];
};

export function getDefaultSiteSettings (): SiteSettings
{    
    return {
        enabled: true,
        hideSurveyEmailAddresses: false,
        apiVideoKey: '',
        features: DefaultApplicationFeatures
    };
}

export function getDefaultCompanyInfo (): CompanyInfo
{
    return {
        name: '',
        address: '',
        altAddress: '',
        city: '',
        zip: '',
        phone: '',
        website: '',
        note: ''
    };
}

export type CompanyInfo = {
    name: string,
    address: string,
    altAddress: string,
    city: string,
    zip: string,
    phone: string,
    website: string,
    note: string;
}